// extracted by mini-css-extract-plugin
export default {"myReviews":"UserReviews_myReviews__G6rA2"};